import Component from '../core/Component'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export const Events = {
    Change: 'visualbackground:change',
}

export default class VisualBackground extends Component {
    prepare() {
        Scroll.on('resize', this.handleResize)
        this.resize()

        if(document.querySelector('.static-Page')) {
            if(!document.querySelector('.static-Page-visual') && document.querySelector('.about-Page-spacer')) {
                document.querySelector('.about-Page-spacer').style.marginBottom = '-31.615384615384617%'
            }
        }
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        const box = this.element.getBoundingClientRect()

        EventBus.emit(Events.Change, {
            height: box.height,
        })
    }
}
